import { SET_COUNTERS } from '../constants';

const countersReducer = (state, action) => {
  const defaultState = {
    counters: [],
    sum: {},
  };

  if (!state) {
    state = defaultState;
  }

  switch (action.type) {
    case SET_COUNTERS:
      // const tmp = {};
      // action.data.forEach((el) => {
      //   if (!tmp[el.client_id]) {
      //     tmp[el.client_id] = el;
      //     tmp[el.client_id].counters = [];
      //   }
      //   tmp[el.client_id].counters.push({
      //     zone_id: el.zone_id,
      //     zone_name: el.zone_name,
      //     count: el.count,
      //     limit: el.limit,
      //     zone_maximum: el.zone_maximum,
      //   });
      // });
      // const counters = Object.keys(tmp).map((el) => tmp[el]);

      // console.log("🚀 ~ countersReducer ~ action.data:", action.data)
      const sum = {};
      action.data?.forEach((counter) => {
        counter.items.forEach((el) => {
          if (!sum[el.zone_name]) {
            sum[el.zone_name] = { free: 0, limit: 0, maximum: 0 };
          }
          sum[el.zone_name].free += el.free;
          sum[el.zone_name].limit += el.limit;
          sum[el.zone_name].maximum += el.maximum;
        });
      });

      return {
        ...state,
        counters: action.data,
        sum,
      };
    default:
      return state;
  }
};

export default countersReducer;
